import PublicationPanel from "./PublicationPanel";
import ur from "./ur";
import ContextMenu from "./ContextMenu";
import G from './Getters';
import { useStore } from 'react-redux';
import { useState } from 'react';
import EditableContent from "./EditableContent";

function numberingToText(numbering){
  if( !numbering ){
    return "Click to set figure number.";
  }
  return "Figure " + numbering.join('');
}

const letters = Array.from("ABCDEFGHIJK")//NOPQRSTUVWXYZ");
const roman = ["i","ii","iii","iv","v","vi","vii","viii","ix","x"];
const numbers = [1,2,3,4,5,6,7,8,9,10];
const items = numbers.map(num => ({
  title:""+num,
  action:""+num,
  data:[num],
  
  /*submenu:letters.map(letter => ({
    action:letter,
    title:letter,
    data:[num,letter],
    submenu:roman.map(rr => ({
      title:rr,
      action:rr,
      data:[num,letter,rr]
    }))
  }))
  */
}))











export default function PublicationFigurePanels({
  publication,
  editorState,
  figurePanels,
  onEvent,
  getNameChangeConflict,
}){


  const ordered = [];
  const unordered = [];

  Object.entries(figurePanels).forEach(([figurePanelId,number]) => {
    console.log('fpi', figurePanelId);
    let toPush=(number?ordered:unordered);
    toPush.push({
      figurePanelId,number
    })
  })



  const lists = [
    { title:"Unordered", list:unordered },
    { title:"Ordered", list:(ordered.sort((a,b) => a.number.localeCompare(b.number)))  },
  ]

  return (
    <div style={{minWidth:0}} class="sg-row outline full-height">
      {lists.map(({title,list}) => {
        if( title === "Unordered" && list.length === 0){ return null; }

        return (
          <div 
          style={{
            overflowY:'scroll',
            borderRight:'1px solid #ccc',

            }}
            class="small-padding rel">
            <h4>{title}</h4>
            {list.map(item => <PublicationPanel {...{
              getNameChangeConflict,
              editorState,
              ...item,
              onEvent
            }}/>)}
          </div>
        )
      })}
    </div>
  )

}
